import React from 'react';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/form/form-base-components/select-coordinator-form.css';
import { SelectCoordinatorGroup } from 'AppSrc/core/components/forms/select-coordinator/select-coordinator-group';
import { SelectCoordinatorTable } from 'AppSrc/core/components/forms/select-coordinator/select-coordinator-table';

// method to generate the error message to display inline within the group selector
const getErrorMessage = ({
  groupId,
  coordinatorId,
  showErrors,
  groupLabel,
  coordinatorLabel,
}) => {
  if (!showErrors) {
    return null;
  }
  if (!groupId) {
    return `Please select a ${groupLabel}`;
  }
  if (!coordinatorId) {
    return `Please select a ${coordinatorLabel} from the group`;
  }
  return null;
};

// Form for selecting a coordinator for the requested CRQ
const SelectCoordinatorForm = ({
  network,
  showErrors,
  groupId,
  setGroup,
  setCoordinator,
  coordinatorId,
  groupLabel,
  coordinatorLabel,
  excludeLoggedInCoordinator,
  crqType,
  isEmergency,
  isICM,
  isOlo,
}) => {
  const errorMessage = getErrorMessage({
    groupId,
    coordinatorId,
    showErrors,
    groupLabel,
    coordinatorLabel,
  });
  const fieldTitle = `Select ${coordinatorLabel}`;
  const placeholder = `Select ${groupLabel}`;
  return (
    <div className="select-coordinator-form">
      <SelectCoordinatorGroup
        setGroup={setGroup}
        fieldTitle={fieldTitle}
        placeholder={placeholder}
        selectedGroupId={groupId}
        errorMessage={errorMessage}
        network={network}
        crqType={crqType}
        isEmergency={isEmergency}
        isICM={isICM}
        isOlo={isOlo}
      />
      {groupId && (
        <SelectCoordinatorTable
          // guarantee remount if group changes
          key={groupId}
          network={network}
          groupId={groupId}
          setCoordinator={setCoordinator}
          coordinatorId={coordinatorId}
          excludeLoggedInCoordinator={excludeLoggedInCoordinator}
          isEmergency={isEmergency}
          isOlo={isOlo}
        />
      )}
    </div>
  );
};

SelectCoordinatorForm.propTypes = {
  network: PropTypes.string,
  showErrors: PropTypes.bool,
  groupId: PropTypes.string,
  setGroup: PropTypes.func,
  coordinatorId: PropTypes.string,
  setCoordinator: PropTypes.func,
  groupLabel: PropTypes.string,
  coordinatorLabel: PropTypes.string,
  excludeLoggedInCoordinator: PropTypes.bool,
  crqType: PropTypes.string,
  isEmergency: PropTypes.bool,
  isICM: PropTypes.bool,
  isOlo: PropTypes.bool,
};

export { SelectCoordinatorForm };
